module.exports = __webpack_public_path__ + "static/img/1.2804f435.png";